<template>
  <!-- Experience Modal -->
  <div id="banked_time_details_modal" class="modal custom-modal fade" role="dialog" ref="myModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between mb-3 px-3">
            <div>
              <h5>{{ userName }}</h5>
            </div>
            <h5>{{ formatDate(date) }}</h5>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Schedule</th>
                <td class="d-flex justify-content-between align-items-center border-0 mt-1">
                  {{ bankedTimeDetails.schedule_fromTime ? bankedTimeDetails.schedule_fromTime : "--" }} - {{
                    bankedTimeDetails.schedule_toTime ? bankedTimeDetails.schedule_toTime : "--" }}
                  <span @click="editScheduleClicked(bankedTimeDetails.schedule)" class="icon-circle cursor-pointer" v-if="(bankedTimeDetails.schedule_fromTime && bankedTimeDetails.schedule_fromTime !== '--') && (userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN')">
                    <i class="fa-solid fa-pen"></i>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">Time on site after break deduction(24 hours)</th>
                <td>{{ bankedTimeDetails.time_on_site_without_break ?
                  toTimeString(bankedTimeDetails.time_on_site_without_break) : "--" }}</td>
              </tr>
               <tr>
                <th scope="row">Allowed break</th>
                <td>{{ bankedTimeDetails.allowed_break_today ?
                  toTimeString(bankedTimeDetails.allowed_break_today) : "--" }}</td>
              </tr>
              <tr>
                <th scope="row">Expected time on site</th>
                <td>{{ bankedTimeDetails.expected_time_on_site ? toTimeString(bankedTimeDetails.expected_time_on_site) :
                  "--" }}</td>
              </tr>
              <tr>
                <th scope="row">Banked time</th>
                <td>{{ bankedTimeDetails.banked_time ? toTimeString(bankedTimeDetails.banked_time) : "--" }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Activities Section -->
          <div class="mt-4" v-if="bankedTimeDetails.activities && bankedTimeDetails.activities.length">
            <h6 class="pb-3">Activities (24 hours)</h6>
            <v-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Time</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Location</th>
                    <th class="text-left">Activity Time</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(a, idx) in bankedTimeDetails.activities" :key="a.id">
                    <td>{{ formatTo12Hour(a.created_at) }}</td>
                    <td>{{ a.type }}</td>
                    <td>{{ getLocationName(a.location_id) }}</td>
                    <td v-if="bankedTimeDetails.activities[idx + 1]">
                      {{ getDiffMinutes(a.created_at, bankedTimeDetails.activities[idx + 1].created_at) }}
                    </td>
                    <td v-else>--</td>
                    <td>
                      <div class="d-flex gap-2" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'">
                        <span class="icon-circle" style="cursor: pointer;" @click="editActivityClicked(a)">
                          <i class="fa-solid fa-pen"></i>
                        </span>
                        <span class="icon-circle" style="cursor: pointer;" @click="deleteActivityClicked(a)">
                          <i class="fa-solid fa-trash-can"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-table>
          </div>

        </div>
        <!-- Sticky Footer with Accept/Reject Buttons -->
        <div class="modal-footer sticky-footer">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-success text-white" @click="updateStatus('Accepted')" :disabled="actionLoading">
              <span v-if="actionLoading && actionType === 'Accepted'" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="fa-solid fa-check me-1"></i>Accept
            </button>
            <button type="button" class="btn btn-danger text-white" @click="updateStatus('Rejected')" :disabled="actionLoading">
              <span v-if="actionLoading && actionType === 'Rejected'" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="fa-solid fa-xmark me-1"></i>Reject
            </button>
            <button type="button" class="btn btn-secondary text-white" @click="submit" :disabled="loader">
              <span v-if="loader" class="spinner-border spinner-border-sm me-1" role="status"></span>
              <i v-else class="fa-solid fa-arrows-rotate me-1"></i>Refresh
            </button>
            <button type="button" class="btn btn-primary text-white" @click="editRecord" data-bs-dismiss="modal">
              <i class="fa-solid fa-pencil me-1"></i>Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Experience Modal -->

  <edit-schedule-modal id="edit_schedule_banked" ref="editSchedule" @editedShift="submit"></edit-schedule-modal>
  <edit-activity-modal id="edit_activity_banked" ref="editActivity" @activityUpdated="submit"></edit-activity-modal>

  <!-- Delete Activity Confirmation Modal -->
  <div class="modal fade" id="delete_activity_modal_banked" tabindex="-1" aria-labelledby="deleteActivityLabelBanked" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteActivityLabelBanked">Delete Activity</h5>
          <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-4 text-start">
          <p>Are you sure you want to delete this activity?</p>
          <div v-if="activityToDelete" class="mb-3">
            <p class="mb-1"><strong>Type:</strong> {{ activityToDelete.type }}</p>
            <p class="mb-0"><strong>Time:</strong> {{ formatTo12Hour(activityToDelete.created_at) }}</p>
          </div>
          <p class="text-danger mb-0"><small>This action cannot be undone. If deleted in the wrong order, the report will contain errors.</small></p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-outline-danger" @click="onDeleteConfirmed" :disabled="isDeleting">
            <span v-if="!isDeleting">Delete</span>
            <div v-else class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { ref } from "vue";
import axios from 'axios';
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../config";
import moment from "moment";
import { minToTimeString, formatTo12Hour, formatDayDateMonthYear, formatDDMMYYYY } from "@/utils/util-funcitons";
import EditScheduleModal from "@/components/modal/edit-schedule-modal.vue";
import EditActivityModal from "@/components/modal/edit-activity-modal.vue";

export default {
  emits: ["statusUpdated", "edit"],
  components: {
    EditScheduleModal,
    EditActivityModal
  },
  data() {
    return {
      select2: null,
      isPositive: true,
      comment: '',
      valueInMins: 0,
      loader: false,
      bankedTimeId: '',
      userDetails: [],
      userId: '',
      date: '',
      bankedTimeDetails: {},
      userName: '',
      dateVar: '',
      locationIdOptions: [],
      actionLoading: false,
      actionType: '',
      recordId: null,
      activityToDelete: null,
      isDeleting: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      savedScrollTop: 0
    };
  },
  mounted() {
    this.getLocationIds();
    this.initModalListeners();
  },
  methods: {
    saveScrollTop() {
      const modalEl = document.getElementById('banked_time_details_modal');
      if (modalEl) {
        const modalBody = modalEl.querySelector('.modal-body');
        this.savedScrollTop = (modalBody ? modalBody.scrollTop : 0) || modalEl.scrollTop || 0;
      }
    },
    initModalListeners() {
      const subModalIds = ['edit_schedule_banked', 'edit_activity_banked', 'delete_activity_modal_banked'];
      subModalIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.addEventListener('hidden.bs.modal', () => {
            // Re-show main modal when sub-modal closes
            const mainModalEl = document.getElementById('banked_time_details_modal');
            if (mainModalEl) {
              const modal = Modal.getOrCreateInstance(mainModalEl);
              modal.show();
            }
          });
        }
      });

      const mainModalEl = document.getElementById('banked_time_details_modal');
      if (mainModalEl) {
        let scrollInterval;

        mainModalEl.addEventListener('show.bs.modal', () => {
          if (this.savedScrollTop > 0) {
            scrollInterval = setInterval(() => {
              const modalBody = mainModalEl.querySelector('.modal-body');
              if (modalBody) modalBody.scrollTop = this.savedScrollTop;
              mainModalEl.scrollTop = this.savedScrollTop;
            }, 10);
          }
        });

        mainModalEl.addEventListener('shown.bs.modal', () => {
          if (scrollInterval) {
            clearInterval(scrollInterval);
          }
          if (this.savedScrollTop > 0) {
            const modalBody = mainModalEl.querySelector('.modal-body');
            if (modalBody) modalBody.scrollTop = this.savedScrollTop;
            mainModalEl.scrollTop = this.savedScrollTop;
            
            setTimeout(() => { 
              if (modalBody) modalBody.scrollTop = this.savedScrollTop;
              mainModalEl.scrollTop = this.savedScrollTop; 
              this.savedScrollTop = 0;
            }, 50);
          }
        });
      }
    },

    updateValues(item, name) {
      this.userDetails = item;
      this.userId = item.user_id;
      this.date = item.date;
      this.dateVar = item.us_date;
      this.userName = name;
      this.recordId = item.id;
      this.submit()
    },

    formatDate(date) {
      if (!date) return '';
      // date comes in DD/MM/YYYY format, convert to YYYY-MM-DD for reliable parsing
      const parts = date.split('/');
      if (parts.length === 3) {
        const isoDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        return formatDayDateMonthYear(isoDate);
      }
      return formatDayDateMonthYear(date);
    },
    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    isNegative(number) {
      return number < 0;
    },

    timeStringToInt(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    },

    submit() {
      this.loader = true;
      
      const monthName = moment(this.dateVar).format("MMMM");
      const year = moment(this.dateVar).format("YYYY");

      const bankedTimeRequest = axios.post(`${VUE_APP_API_BASE_URL}/banked-time/get-details`, {
        date: this.dateVar,
        user_id: this.userId
      });

      const scheduleRequest = axios.get(`${VUE_APP_API_BASE_URL}/user-schedule/all`, {
        params: {
          employee_id: this.userId,
          month: monthName,
          year: year
        }
      });

      axios.all([bankedTimeRequest, scheduleRequest])
        .then(axios.spread((bankedTimeResponse, scheduleResponse) => {
          if (bankedTimeResponse.data.status) {
            this.bankedTimeDetails = bankedTimeResponse.data.data;
          }

          if (scheduleResponse.data.status && scheduleResponse.data.data.data?.length) {
            const userData = scheduleResponse.data.data.data.find(u => u.id == this.userId);
            if (userData && userData.user_schedule) {
              // Find the schedule for the specific date. Note: dates in user_schedule might be YYYY-MM-DD
              const schedule = userData.user_schedule.find(s => {
                // The API might return date as YYYY-MM-DD or DD/MM/YYYY.
                // shift-scheduling.vue converts it to DD/MM/YYYY for display, let's keep it robust.
                return s.date === this.date || s.date === this.dateVar || formatDDMMYYYY(s.date) === this.date;
              });
              
              if (schedule) {
                // Ensure reactivity
                this.bankedTimeDetails = {
                  ...this.bankedTimeDetails,
                  schedule: schedule
                };
              }
            }
          }
        }))
        .catch((error) => {
          console.error("Error fetching details or schedule:", error);
          this.$toast.error("Failed to load some data details.");
        })
        .finally(() => {
          this.loader = false;
        });
    },

    formatTo12Hour(dateTime) {
      return formatTo12Hour(dateTime);
    },

    getLocationName(id) {
      if (!id) return 'Unrecognized';
      const location = this.locationIdOptions.find(item => item.id === id);
      return location ? location.name : 'Unrecognized';
    },

    getDiffMinutes(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffMs = endDate - startDate;
      const totalMinutes = Math.floor(diffMs / 60000);

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      const paddedHours = hours.toString().padStart(2, '0');
      const paddedMinutes = minutes.toString().padStart(2, '0');

      return `${paddedHours}hr : ${paddedMinutes}min`;
    },

    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data;
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async updateStatus(option) {
      this.actionLoading = true;
      this.actionType = option;
      await axios.post(`${VUE_APP_API_BASE_URL}/task/${this.recordId}/update-status`, {
        status: option,
      }).then((response) => {
        if (response.data.status) {
          this.$toast.success(response.data.message);
          this.$refs.Close.click();
          this.$emit('statusUpdated');
        } else {
          this.$toast.error(response.data.message || response.data.errors);
        }
      }).catch((error) => {
        console.log('error ', error);
        this.$toast.error('An error occurred');
      }).finally(() => {
        this.actionLoading = false;
        this.actionType = '';
      });
    },

    editRecord() {
      this.$emit('edit', this.userDetails);
      const modal = new Modal(document.getElementById('edit_banked_time_modal'));
      modal.show();
    },

    editScheduleClicked(record) {
      this.saveScrollTop();
      const scheduleData = record || this.bankedTimeDetails?.schedule || this.bankedTimeDetails?.user_schedule;
      
      if (!scheduleData) {
        this.$toast.error('Schedule data not found');
        return;
      }
      
      if (this.$refs.editSchedule) {
        this.$refs.editSchedule.updateValues(scheduleData);
        
        // Hide main modal
        const mainModalEl = document.getElementById('banked_time_details_modal');
        if (mainModalEl) {
          const mainModal = Modal.getInstance(mainModalEl);
          if (mainModal) mainModal.hide();
        }

        setTimeout(() => {
          const modalElement = document.getElementById('edit_schedule_banked');
          if (modalElement) {
             const modal = Modal.getOrCreateInstance(modalElement);
             modal.show();
          }
        }, 100);
      }
    },

    editActivityClicked(record) {
      this.saveScrollTop();
      this.$refs.editActivity.updateValues(record);
      
      // Hide main modal
      const mainModalEl = document.getElementById('banked_time_details_modal');
      if (mainModalEl) {
        const mainModal = Modal.getInstance(mainModalEl);
        if (mainModal) mainModal.hide();
      }

      const modalElement = document.getElementById('edit_activity_banked');
      if (modalElement) {
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.show();
      }
    },

    deleteActivityClicked(activity) {
      this.saveScrollTop();
      this.activityToDelete = activity;
      
      // Hide main modal
      const mainModalEl = document.getElementById('banked_time_details_modal');
      if (mainModalEl) {
        const mainModal = Modal.getInstance(mainModalEl);
        if (mainModal) mainModal.hide();
      }

      const modalElement = document.getElementById('delete_activity_modal_banked');
      if (modalElement) {
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.show();
      }
    },

    async onDeleteConfirmed() {
      if (!this.activityToDelete) return;
      await this.deleteActivity(this.activityToDelete.id);
      const modal = Modal.getInstance(document.getElementById('delete_activity_modal_banked'));
      if (modal) modal.hide();
      this.activityToDelete = null;
    },

    async deleteActivity(activityId) {
      this.isDeleting = true;
      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/activity/delete`, { id: activityId });
        if (response.data.status) {
          this.$toast.success('Activity deleted successfully');
          this.submit();
        }
      } finally {
        this.isDeleting = false;
      }
    }
  },

};
</script>
<style scoped>
.sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  justify-content: flex-end;
  padding: 1rem;
  z-index: 10;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.btn-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:active {
  background-color: #007bff;
  border-color: #007bff;
}

/* Ensure sub-modals stack above the details modal */
.modal-lg ~ .modal,
.modal-body .modal {
  z-index: 1070 !important;
}

:deep(.modal-content) {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), 0 5px 15px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
}

.icon-circle {
  display: flex;
  background-color: #f7f7f7;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  width: 30px;
  aspect-ratio: 1;
}

.close-btn {
  background-color: #ffffff00;
  font-size: 25px;
  color: white;
}
</style>
